import { ShippingContact } from '@wix/cashier-express-checkout-widget/dist/src/types/Shipping';
import { BillingContact } from '@wix/cashier-express-checkout-widget/dist/src/types/BillingContact';
import { CashierContact } from '../checkoutTypes';

const CASHIER_USA_SUBDIVISIONS_WE_USE_AS_COUNTRIES = [
  'AS', // American Samoa
  'FM', // Micronesia,
  'GU', // Guam,
  'MP', // Northern Mariana Islands,
  'PW', // Palau,
  'VI', // U.S. Virgin Islands
  'PR', // Puerto Rico,
];

export function mapToCashierShippingAddress(
  shippingAddress: Partial<ShippingContact> = {},
  billingAddress: Partial<BillingContact> = {},
): CashierContact {
  return mapCashierAddressToEcomAddress({
    countryCode: shippingAddress.countryCode ?? billingAddress.countryCode,
    city: shippingAddress.city,
    postalCode: shippingAddress.postalCode,
    addressLine1: shippingAddress.addressLine1,
    addressLine2: shippingAddress.addressLine2,
    firstName: shippingAddress.firstName ?? billingAddress.firstName,
    lastName: shippingAddress.lastName ?? billingAddress.lastName,
    state: shippingAddress.state,
    email: billingAddress.email,
    phone: shippingAddress.phone || billingAddress.phone,
  });
}

export function mapCashierAddressToEcomAddress(
  address: Partial<CashierContact> = {},
): CashierContact {
  return {
    ...address,
    ...mapCashierCountryToEcomCountry(address.countryCode, address.state),
  };
}

function mapCashierCountryToEcomCountry(
  cashierCountryCode: string | undefined,
  state: string | undefined,
): { countryCode: string; state?: string } {
  if (
    cashierCountryCode === 'US' &&
    state &&
    CASHIER_USA_SUBDIVISIONS_WE_USE_AS_COUNTRIES.includes(state)
  ) {
    return { countryCode: state, state: undefined };
  }

  const countryCode = cashierCountryCode === 'C2' ? 'CN' : cashierCountryCode!;

  return {
    countryCode,
    state: state ? `${countryCode}-${state}` : undefined,
  };
}
